export const DEFAULT_SELECTED = 'Popular Brands';
export const ALL_BRANDS = 'All Brands';
export const PLACEHOLDER = 'Search Brands';
export const MASTER_DATA_ID = '007';
export const BRANDS_CATEGORY_NAME = 'Brands';
export const ALL_BRANDS_CHANNEL_ID = 'all brands';

export const META_INFO = {
  title:
    "All Brands | Designer Women's Clothing - Shop for Women's Fashion Clothing Online | Nykaa Fashion",
  description:
    "All Brands | Women's clothing &amp; accessories: Buy designer women's clothes like coats, crop tops, dresses, gowns, tops, kurtis, lehengas, sarees &amp; more at Nykaa Fashion. Click here to explore the latest collection of womens fashion apparels from reputed fashion designers!",
  keywords:
    'all brands, womens clothing, ladies wear, womens clothing online, womens fashion, online shopping womens clothing, womens wear',
};
